export interface CurrencyMaskConfig {
  allowNegative?: boolean;
  allowZero?: boolean;
  decimal?: string;
  precision?: number;
  nullable?: boolean;
  min?: number | null;
  max?: number | null;
}

export const DEFAULT_CURRENCY_MASK_CONFIG: CurrencyMaskConfig = {
  allowNegative: true,
  allowZero: true,
  decimal: '.',
  precision: 2,
  nullable: false,
  min: null,
  max: null
};
